import { Alert, styled } from '@mui/material';
import { Typography } from '@mui/material';

const AlertContainer = styled(Alert)({
  paddingTop: 0,
  paddingBottom: 0,
});
const Icon = styled('img')({
  width: '16px',
  height: '16px',
  margin: 'auto',
});
const Text = styled(Typography)({
  fontSize: '12px',
});

export const MekiCreditsSelectedAlert = () => {
  return (
    <AlertContainer
      severity="success"
      icon={<Icon src={'/assets/images/okIcon.svg'} />}
    >
      <Text>Créditos Meki aplicados exitosamente</Text>
    </AlertContainer>
  );
};
